import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=1f38ec36"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f38ec36')) {
      api.createRecord('1f38ec36', component.options)
    } else {
      api.reload('1f38ec36', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=1f38ec36", function () {
      api.rerender('1f38ec36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_privacy_policy/PrivacyPolicy.vue"
export default component.exports